<template>
  <v-ons-page>
    <p style="text-align: center">
      Change the settings.
    </p>
  </v-ons-page>
</template>

<script>
  export default {
    props: ['toggleMenu']
  }
</script>



// WEBPACK FOOTER //
// settingsPage.vue?a0a28a74